import { LOADING_STATE } from "types/general";
import { IState } from "./types";

export const ASSET_DASHBOARD_SLICE_NAME = "assetDashboard";

export const initialState: IState = {
  summary: {
    loadingState: LOADING_STATE.idle,
  },
  competitiveSet: {
    data: [],
    loadingState: LOADING_STATE.idle,
  },
};
